import { css } from '@emotion/react';
import { memo, ReactElement } from 'react';

import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';
import { useTheme } from '../../theme/useTheme';

export const Component = ({ className, onClick }: { className: string; onClick: VoidFunction }): ReactElement => {
	const {
		allSettings: {
			icons: {
				closeWidgetIconDesktop: { fill },
			},
		},
	} = useTheme();
	return (
		<div className={className} onClick={onClick}>
			<svg fill="none" viewBox="0 0 24 24">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.293 4.293a1 1 0 0 0 0 1.414l14 14a1 1 0 0 0 1.414-1.414l-14-14a1 1 0 0 0-1.414 0Z"
					fill={fill}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M19.707 4.293a1 1 0 0 0-1.414 0l-14 14a1 1 0 1 0 1.414 1.414l14-14a1 1 0 0 0 0-1.414Z"
					fill={fill}
				/>
			</svg>
		</div>
	);
};

export const CloseChatDesktopButton = styled(memo(Component))(
	({
		theme: {
			allSettings: {
				icons: {
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					closeWidgetIconDesktop: { size, ...others },
				},
			},
		},
	}: {
		theme: Theme;
	}) => ({ width: size, height: size, ...others }),
	css`
		align-self: start;
		border-radius: 1000px;
		cursor: pointer;
		display: inline-block;
		margin-left: 16px;
		position: flex;
	`
);
